import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { NavLink } from 'src/app/shared/models/interfaces/nav-link.model';
import { UiService } from 'src/app/shared/services/ui.service';
import { LanguageService } from 'src/app/shared/services/language.service';

@Component({
    selector: 'app-nav-list',
    templateUrl: './nav-list.component.html',
    styleUrls: ['./nav-list.component.scss']
})
export class NavListComponent implements OnInit, OnDestroy {
    @Input() links: NavLink[];
    @Input() isLittleMode: boolean;

    private subscription = new Subscription();

    isRouteLoading: boolean;
    selLanguage: string;

    constructor(
        private uiSrv: UiService,
        private languageSrv: LanguageService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    private initSubscriptions(): void {
        this.subscription.add(
            this.uiSrv.routeLoadingStateChanged
            .subscribe(loadingState => {
                this.isRouteLoading = loadingState;
            })
        );
        this.subscription.add(
            this.languageSrv.languageChanged
            .subscribe(selLang => {
                this.selLanguage = selLang;
            })
        );
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
